var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.originalData.length > 0)?_c('v-pagination',{attrs:{"length":_vm.paginationLength,"total-visible":_vm.totalVisiblePages,"circle":""},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }